var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2_1_"},React.createElement("path",{"d":"M78.5,0C58.1,0,34.9,12.2,18.9,29.7h55.3l-5.9,12.6h-12L43.9,68.9H30.8l12.4-26.6H9.3c-1.4,2.4-3,5.3-4.1,7.7\n\t\tc-12.9,27.6-0.9,50,26.7,50c4.9,0,9-0.7,14.1-2l18.5-39.7H51.8l6.1-13.1H70l7.2-15.5h13L61.2,92c17.8-9,35.8-24.4,44-42\n\t\tC118.1,22.4,106.1,0,78.5,0z"})));
}

Logo.defaultProps = {"version":"1.1","id":"logo","x":"0px","y":"0px","viewBox":"0 0 110.4 100","style":{"enableBackground":"new 0 0 110.4 100"},"xmlSpace":"preserve"};

module.exports = Logo;

Logo.default = Logo;
